export const locale = {
    lang: "es-ES",
    data: {
        ADD_CREDIT_CARD: {
            TITLE: "Añadir nueva tarjeta de crédito",
            ADD_BUTTON: "Guardar",
            CANCEL_BUTTON: "Cancelar"
        }
    }
};
